export default {
  title: 'Mon compte',
  newPassword: {
    title1: 'Définissez votre mot de passe',
    title2: 'Changer de mot de passe',
    email: {
      text: 'Adresse courriel',
    },
    oldPassword: {
      text: 'Ancien mot de passe',
      warning: 'Veuillez renseigner votre ancien mot passe',
    },
    newPassword: {
      text: 'Choisissez votre mot de passe',
      warning: 'Veuillez renseigner un nouveau mot de passe',
      lengthCondition: 'Le nouveau mot de passe doit faire au minimum 10 caractères',
      lengthCondition2: 'Le nouveau mot de passe doit faire au minimum 8 caractères',
      caseCondition: 'Le nouveau mot de passe doit contenir une minuscule et une majuscule',
      specialCondition: 'Le nouveau mot de passe doit contenir un caractère spécial (caractère hors chiffres/lettres)',
      rules: {
        title: 'Votre mot de passe doit contenir :',
        lengthCondition: 'Au minimum 10 caractères',
        lengthCondition2: 'Au minimum 8 caractères',
        caseCondition: 'Une minuscule et une majuscule',
        specialCondition: 'Un caractère spécial (caractère hors chiffres/lettres)',
      },
    },
    newPasswordConfirmation: {
      text: 'Confirmez le mot de passe',
      warning: 'Veuillez confirmer le nouveau mot de passe',
      passwordConfirmationEqual: 'Le mot de passe et sa confirmation ne sont pas égaux',
    },
    submit: {
      change: 'Changer de mot de passe',
      new: 'Enregistrer',
    },
  },
  newEmail: {
    title: 'Changer d\'adresse email',
    email: {
      text: 'Email',
      warning: 'Veuillez renseigner un email valide',
    },
    password: {
      text: 'Mot de passe',
      warning: 'Veuillez renseigner votre mot de passe',
    },
    submit: 'Changer d\'adresse email',
  },
};
